import { Drawer, Title, type DrawerProps } from "@mantine/core";

// Inline styles so they beat the fixed height Mantine derives from `size`.
const STYLES: DrawerProps["styles"] = {
  // Close cross on its own row above the title, so a long title gets the full width.
  header: {
    flexDirection: "column-reverse",
    alignItems: "stretch",
    gap: "var(--mantine-spacing-xs)",
  },
  close: { alignSelf: "flex-end" },
  content: {
    height: "auto",
    maxHeight: "95dvh",
    display: "flex",
    flexDirection: "column",
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    // 32px per Figma, on top of the home-indicator inset.
    paddingBottom: "calc(32px + env(safe-area-inset-bottom, 0px))",
  },
};

/** Content-height bottom sheet. `title` is plain text. */
export function BottomSheet({ title, children, ...props }: DrawerProps) {
  return (
    <Drawer
      position="bottom"
      radius="lg"
      padding="lg"
      styles={STYLES}
      closeButtonProps={{ "aria-label": "Stäng" }}
      title={
        <Title
          order={2}
          fz="h3"
          lh="h3"
          ff="var(--wallet-font-family-sambla-sans)"
        >
          {title}
        </Title>
      }
      {...props}
    >
      {children}
    </Drawer>
  );
}
